import type { FilterValue } from '@/components/table-filters/constants';
import { ensureGetList } from '@/requests/hooks/use-get-list';
import type { QueryParams } from '@/requests/types';
import type { OrganizationUser } from '@pigello/pigello-matrix';

export type GetUsersByWorkEngagementOptions = {
  queryParams?: QueryParams<OrganizationUser>;
}

export async function getUsersByWorkEngagement(
  workEngagementId: FilterValue,
  opts?: GetUsersByWorkEngagementOptions
): Promise<string[]> {
  const users = await ensureGetList({
    modelName: 'organizationuser',
    queryParams: {
      page: 1,
      pageSize: 500,
      ...opts?.queryParams,
      filters: {
        work_engagements: { noop: workEngagementId },
        ...opts?.queryParams?.filters,
      },
    },
  });

  return users.list.map((user) => user.id);
}
